import { useState, useRef, useEffect } from "react";

import { useTranslation } from "react-i18next";

import { env } from "config/env";
import { changeLanguageWithTenant } from "multitenancy/i18n";

import { Container, Selected, Dropdown, Option } from "./styles";

const LANGUAGE_LABELS: Record<string, string> = {
  "pt-BR": "Português (BR)",
  "pt-PT": "Português (PT)",
  "en-US": "English",
  "es-ES": "Español",
};

export function LanguageSelector() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  if (!env.LANGUAGE_SELECTOR_ENABLED) return null;

  const languages = env.AVAILABLE_LANGUAGES.map((code) => ({
    code,
    label: LANGUAGE_LABELS[code] || code,
  }));

  const current =
    languages.find((l) => l.code === i18n.language) || languages[0];

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const handleSelect = async (code: string) => {
    setOpen(false);
    localStorage.setItem("userLanguage", code);
    await changeLanguageWithTenant(code);
  };

  return (
    <Container ref={ref}>
      <Selected onClick={() => setOpen(!open)}>
        {current.label}
        <span>{open ? "▲" : "▼"}</span>
      </Selected>
      {open && (
        <Dropdown>
          {languages.map((lang) => (
            <Option
              key={lang.code}
              $active={lang.code === i18n.language}
              onClick={() => handleSelect(lang.code)}
            >
              {lang.label}
            </Option>
          ))}
        </Dropdown>
      )}
    </Container>
  );
}
